/** @jsx jsx */
/* eslint-disable no-use-before-define */
import React from 'react'
import { jsx, css } from '@emotion/core'
import { isEmpty, mediaQueries } from '../../../twd/twd'
import Top5 from './top5'
import useScatterGraph from '../use-scatter-graph';

export default () => {

    const { customTickers, setCustomTickers } = useScatterGraph()

    const inputRef = React.useRef()
    React.useEffect(() => {
        inputRef.current.value = customTickers.join(', ')
    }, [customTickers])

    const [customError, setCustomError] = React.useState()

    return <React.Fragment>
    <div className="vertical-offset-xs"
        style={{
            backgroundColor:"#f6f6f6",
            padding:"10px"
        }}>
    <div className="row">
    <div className="col-md-7 col-xs-12">

    <div className="form-horizontal">
        <div className="form-group col-md-6 col-lg-5" style={{marginBottom:0}}>
        <label htmlFor="corporates-scatter-graph-top5">Top 5 actively traded issuers</label>
        <Top5 id="corporates-scatter-graph-top5" />
        </div>

        <label className="control-label col-md-1 col-lg-1 col-xs-12"
            css={labelCss}>or</label>

        <div className={'form-group col-md-4 col-lg-4' + (customError ? ' has-error': '')} style={{marginBottom:0}}>
        <label htmlFor="corporates-scatter-graph-custom-issuer">Custom issuer</label>
        <input
            id="corporates-scatter-graph-custom-issuer"
            data-name="corporates-scatter-graph-custom-issuer"
            ref={inputRef}
            type="text"
            placeholder="Symbol"
            className="form-control"
            onBlur={(e) => {
                setTimeout(() => {
                    setCustomError('')

                    let s = inputRef.current.value
                    let arr = s.split(',').map(a => a.trim()).filter(Boolean)

                    if (arr.length===0) {
                        if (!isEmpty(customTickers)) {
                            setCustomTickers([])
                        }
                        return
                    }

                    if (arr.length>5) {
                        setCustomError('Please enter up-to 5 symbols')
                        return
                    }

                    setCustomTickers([...arr])
                }, 100)
            }}

            onKeyPress={(e) => {
                let key = e.key
                if (!(key===13 || key === 'Enter')) return
                e.preventDefault()
                e.currentTarget.blur()
            }}
            />
        <label className="field-status">{customError}</label>
        </div>

        <button
            data-name="corporates-scatter-graph-clear-link"
            className="link-button control-label col-md-1 col-xs-12"
            css={clearCss}
            onClick={() => {
                setCustomError('')

                let e = inputRef.current
                e.value = ''
                e.focus()

                setCustomTickers([])
            }}
            >Clear</button>
    </div>

    </div></div></div>
    </React.Fragment>
}

const labelCss = css`
    ${mediaQueries.xs} {
        text-align:center;
    }
    ${mediaQueries.notXs} {
        margin-top: 20px;
    }
`

const clearCss = css `
    ${mediaQueries.xs} {
        text-align:center;
    }
    ${mediaQueries.notXs} {
        margin-left: 5px;
        margin-top: 23px;
    }
`


// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/criteria/form.js